import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AnalyticsUIState } from 'app/main/analytics/analytics.types';
import { State, RouteState } from 'app/main/analytics/reducers';

export const getRouteState = createFeatureSelector<State, RouteState>('analytics');

export const selectAnalyticsUIState = createSelector(
    getRouteState,
    ({ ui }): AnalyticsUIState => ui
);

export const selectReport = createSelector(
    selectAnalyticsUIState,
    ({ report }) => report
);

export const selectReportSelectedGroupKey = createSelector(
    selectReport,
    ({ selectedGroup }): string => selectedGroup !== null ? selectedGroup.key : ''
);
export const selectReportSelectedGroupName = createSelector(
    selectReport,
    ({ selectedGroup }): string => selectedGroup !== null ? selectedGroup.name : ''
);

export const selectSelectedTab = createSelector(
    selectAnalyticsUIState,
    ({ selectedTab }) => selectedTab
);
